<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-icon class="small-icon" v-if="taxi.disabled_access == true">accessible</v-icon>
        <v-icon class="small-icon" v-if="taxi.pets_allowed == true">pets</v-icon>
        <v-icon class="small-icon" v-if="taxi.premium_vehicle != false">stars</v-icon>
        <p style="display: inline" class="small-text" v-if="taxi.wide == true">wide</p>
      </span>
    </template>
    <span>
      <ul>
        <li>
          <p class="light-list-text" v-if="taxi.wide == true">Wide Vehicle</p>
        </li>
        <li v-if="taxi.disabled_access == true">
          <v-icon color="white" class="small-icon">accessible</v-icon>
          {{'Disabled Access'}}
        </li>
        <li v-if="taxi.pets_allowed == true">
          <v-icon color="white" class="small-icon">pets</v-icon>
          {{'Pets Allowed'}}
        </li>
        <li></li>
        <li v-if="taxi.premium_vehicle != false">
          <v-icon color="white" class="small-icon">stars</v-icon>
          {{'Premium Vehicle'}}
        </li>
      </ul>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "attributes-for-booking-cell",
  props: {
    taxi: Object
  },
  mounted: function() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.small-icon {
  font-size: 14px !important;
  padding-right: 3px;
  color: black;
}

.light-list-text {
  color: white !important;
  font-size: 12px !important;
}

.small-text {
  font-size: 10px !important;
  color: black;
}
</style>
